import { SelectableItem } from '../common/selectableItem';

export enum CaType {
    None = 0,
    PublicBody = 100,
    EuInstitution = 200,
    Ministry = 300,
    NationalAgency = 400,
    RegionalAgency = 500,
    RegionalAuthority = 600,
    Other = 700
}

export enum CaActivity {
    None = 0,
    Defence = 100,
    EconomicAndFinancialAffairs = 200,
    Education = 300,
    Environment = 400,
    GeneralPublicServices = 500,
    Health = 600,
    HousingAndCommunityAmenities = 700,
    PublicOrderAndSafety = 800,
    RecreationCultureAndReligion = 900,
    SocialProtection = 1000,
    Other = 1100
}

export enum CeActivity {
    None = 0,
    AirportRelatedActivities = 100,
    Electricity = 200,
    ExplorationExtractionCoalOtherSolidFuel = 300,
    ExplorationExtractGasOil = 400,
    PortRelatedActivities = 500,
    PostalServices = 600,
    ProductionTransportDistributionGasHeat = 700,
    RailwayServices = 800,
    UrbanRailwayTramwayTrolleybusBusServices = 900,
    Water = 1000,
    Other = 2000
}

export enum ProcedureType {
    None = 0,
    AcceleratedProcedure = 1,
    AwardContractWithoutCall = 2,
    CompetitiveDialogue = 3,
    CompetitiveNegotiation = 4,
    InnovationPartnership = 5,
    NegotiatedWithPriorCall = 6,
    Open = 7,
    Restricted = 8,
    NegotiatedWithoutPublication = 9
}

export enum ContractType {
    Services = 0,
    Supplies = 1,
    Works = 2
}

export enum LotSubmission {
    NotSplit = 100,
    AllLots = 200,
    OneOnly = 300,
    MaxNumber = 400
}

export enum AcType {
    Quality = 100,
    Cost = 200,
    Price = 300
}

export enum FormType {
    None = 0,
    F012014 = 100,
    F022014 = 200,
    F032014 = 300,
    F042014 = 400,
    F052014 = 500,
    F062014 = 600,
    F082014 = 700,
    F152014 = 800,
    F212014 = 900,
    F222014 = 1000,
    F232014 = 1100,
    F242014 = 1200,
    F252014 = 1300
}

export class OjeuEnumsToSelectList {
    static getCaTypeList(): Array<SelectableItem<CaType>> {
        var output = [];

        output.push({ value: CaType.None, text: 'None' });
        output.push({ value: CaType.PublicBody, text: 'Body governed by public law' });
        output.push({ value: CaType.EuInstitution, text: 'European institution/agency or international organisation' });
        output.push({ value: CaType.Ministry, text: 'Ministry or any other national or federal authority, including their regional or local subdivisions' });
        output.push({ value: CaType.NationalAgency, text: 'National or federal agency/office' });
        output.push({ value: CaType.RegionalAgency, text: 'Regional or local agency/office' });
        output.push({ value: CaType.RegionalAuthority, text: 'Regional or local authority' });
        output.push({ value: CaType.Other, text: 'Other' });

        return output;
    }

    static getCaActivityList(): Array<SelectableItem<CaActivity>> {
        var output = [];

        output.push({ value: CaActivity.None, text: 'None' });
        output.push({ value: CaActivity.Defence, text: 'Defence' });
        output.push({ value: CaActivity.EconomicAndFinancialAffairs, text: 'Economic and financial affairs' });
        output.push({ value: CaActivity.Education, text: 'Education' });
        output.push({ value: CaActivity.Environment, text: 'Environment' });
        output.push({ value: CaActivity.GeneralPublicServices, text: 'General public services' });
        output.push({ value: CaActivity.Health, text: 'Health' });
        output.push({ value: CaActivity.HousingAndCommunityAmenities, text: 'Housing and community amenities' });
        output.push({ value: CaActivity.PublicOrderAndSafety, text: 'Public order and safety' });
        output.push({ value: CaActivity.RecreationCultureAndReligion, text: 'Recreation, culture and religion' });
        output.push({ value: CaActivity.SocialProtection, text: 'Social protection' });
        output.push({ value: CaActivity.Other, text: 'Other' });

        return output;
    }

    static getCeActivityList(): Array<SelectableItem<CeActivity>> {
        var output = [];

        output.push({ value: CeActivity.None, text: 'None' });
        output.push({ value: CeActivity.AirportRelatedActivities, text: 'Airport related activities' });
        output.push({ value: CeActivity.Electricity, text: 'Electricity' });
        output.push({ value: CeActivity.ExplorationExtractionCoalOtherSolidFuel, text: 'Exploration and extraction of coal and other solid fuel' });
        output.push({ value: CeActivity.ExplorationExtractGasOil, text: 'Exploration and extraction of gas and oil' });
        output.push({ value: CeActivity.PortRelatedActivities, text: 'Port related activities' });
        output.push({ value: CeActivity.PostalServices, text: 'Postal services' });
        output.push({ value: CeActivity.ProductionTransportDistributionGasHeat, text: 'Production, transport and distribution of gas and heat' });
        output.push({ value: CeActivity.RailwayServices, text: 'Railway services' });
        output.push({ value: CeActivity.UrbanRailwayTramwayTrolleybusBusServices, text: 'Urban railway, tramway, trolleybus and bus services' });
        output.push({ value: CeActivity.Water, text: 'Water' });
        output.push({ value: CeActivity.Other, text: 'Other' });

        return output;
    }

    static getProcedureTypeList(): Array<SelectableItem<ProcedureType>> {
        var output = [];
        
        output.push({ value: ProcedureType.AcceleratedProcedure, text: 'Accelerated procedure' });
        output.push({ value: ProcedureType.AwardContractWithoutCall, text: 'Award contract without call' });
        output.push({ value: ProcedureType.CompetitiveDialogue, text: 'Competitive dialogue' });
        output.push({ value: ProcedureType.CompetitiveNegotiation, text: 'Competitive procedure with negotiation' });
        output.push({ value: ProcedureType.InnovationPartnership, text: 'Innovation partnership' });
        output.push({ value: ProcedureType.NegotiatedWithPriorCall, text: 'Negotiated procedure with prior call for competition' });
        output.push({ value: ProcedureType.Open, text: 'Open procedure' });
        output.push({ value: ProcedureType.Restricted, text: 'Restricted procedure' });
        output.push({ value: ProcedureType.NegotiatedWithoutPublication, text: '' });

        return output;
    }

    static getContractTypeList(): Array<SelectableItem<ContractType>> {
        var output = [];

        output.push({ value: ContractType.Services, text: 'Services' });
        output.push({ value: ContractType.Supplies, text: 'Supplies' });
        output.push({ value: ContractType.Works, text: 'Works' });

        return output;
    }

    static getLotSubmissionList(): Array<SelectableItem<LotSubmission>> {
        var output = [];

        output.push({ value: LotSubmission.NotSplit, text: 'Not Split' });
        output.push({ value: LotSubmission.AllLots, text: 'All Lots' });
        output.push({ value: LotSubmission.OneOnly, text: 'One Only' });
        output.push({ value: LotSubmission.MaxNumber, text: 'Maximum Number' });

        return output;
    }

    static getAcTypeList(): Array<SelectableItem<AcType>> {
        var output = [];

        output.push({ value: AcType.Quality, text: 'Quality' });
        output.push({ value: AcType.Cost, text: 'Cost' });
        output.push({ value: AcType.Price, text: 'Price' });

        return output;
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/models/notices/ojeu.notice.enums.ts